import React from 'react'
import Lightning_Section from '../Products_List_Icons/Lightning_Section.png'
import Cable_Section from '../Products_List_Icons/Cable_Section.png'
import Havakesh_Section from '../Products_List_Icons/Havakesh.png'
import Soti_Tasviri_Section from '../Products_List_Icons/Soti_Tasviri_Section.png'
import Switch_Section from '../Products_List_Icons/Switch_Section.png'
import Other_Section from '../Products_List_Icons/Other_Section.png'
import Remote_Section from '../Products_List_Icons/Remote_Section.png'
import '../Style/Products.css'
import { Link } from 'react-router-dom'

function Product() {
    return (
        <>
            <div className='products-list'>
                <div className='title'>دسته بندی محصولات</div>
                <div className='products-row'>
                    <div className='products-grid'>
                        <Link to={"/product/روشنایی"} className='product'>
                            <img src={Lightning_Section} className='product-icon' alt=''/>
                            <div className='product-title'>روشنایی</div>
                        </Link>
                        <Link to={"/product/روشنایی"} className='product'>
                            <img src={Cable_Section} className='product-icon' alt=''/>
                            <div className='product-title'>کابل و سیم</div>
                        </Link>
                        <Link to={"/product/روشنایی"} className='product'>
                            <img src={Soti_Tasviri_Section} className='product-icon' alt=''/>
                            <div className='product-title'>صوتی و تصویری</div>
                        </Link>
                        <Link to={"/product/روشنایی"} className='product'>
                            <img src={Havakesh_Section} className='product-icon' alt=''/>
                            <div className='product-title'>تهویه هوا</div>
                        </Link>
                        <Link to={"/product/روشنایی"} className='product'>
                            <img src={Switch_Section} className='product-icon' alt=''/>
                            <div className='product-title'>کلید و پریز</div>
                        </Link>
                        <Link to={"/product/روشنایی"} className='product'>
                            <img src={Other_Section} className='product-icon' alt=''/>
                            <div className='product-title'>لوازم جانبی برق</div>
                        </Link>
                        <Link to={"/product/روشنایی"} className='product'>
                            <img src={Remote_Section} className='product-icon' alt=''/>
                            <div className='product-title'>ریموت و کنترل</div>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Product